// third-party

// assets
import {
  LineChartOutlined,
  IdcardOutlined,
  DatabaseOutlined,
  BuildOutlined,
  CalendarOutlined,
  CustomerServiceOutlined,
  MessageOutlined,
  ShoppingCartOutlined,
  UserOutlined,
  AppstoreAddOutlined,
  FileTextOutlined,
  ChromeOutlined
} from '@ant-design/icons';

// type
import { NavItemType } from 'types/menu';

// icons
const icons = {
  BuildOutlined,
  CalendarOutlined,
  CustomerServiceOutlined,
  MessageOutlined,
  ShoppingCartOutlined,
  UserOutlined,
  AppstoreAddOutlined,
  FileTextOutlined,
  LineChartOutlined,
  IdcardOutlined,
  DatabaseOutlined,
  ChromeOutlined
};

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //

const reporting: NavItemType = {
  id: 'reporting',
  url: '/reporting/reprort-construction/',
  icon: icons.IdcardOutlined,
  type: 'group',
  children: [
    {
      id: 'reporting-assets',
      title: 'Reporting',
      type: 'collapse',
      icon: icons.ChromeOutlined,
      breadcrumbs: true,
      children: [
        {
          id: 'reprort-construction',
          title: 'Reprort Construction',
          type: 'item',
          url: '/reporting/reprort-construction/'
        },
        {
          id: 'automation',
          title: 'Automation',
          type: 'item',
          url: '/reporting/automation/'
        }
      ]
    }
  ]
};

export default reporting;
